import API from '@config/api';

const getTickets = () => API.get('/manage_support/tickets');
const getTicketMessages = id => API.get(`/manage_support/ticket/${id}`);
const sendMessage = (id, text) => API.post(`/manage_support/ticket/${id}/message`, {text});
const updateTicket = (id, data) => API.patch(`/manage_support/ticket/${id}`, data);

export {getTickets, getTicketMessages, sendMessage, updateTicket};
